<template>
    <div>
        <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="型号管理" name="model-mng"><ModelMng></ModelMng></el-tab-pane>
            <el-tab-pane label="仓储状态" name="storage-mng"><StorageMng></StorageMng></el-tab-pane>
            <el-tab-pane label="激活状态" name="active-mng"><ActiveMng></ActiveMng></el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import ModelMng from '../../components/dev/basic/ModelMng'
    import StorageMng from '../../components/dev/basic/StorageMng'
    import ActiveMng from '../../components/dev/basic/ActiveMng'
    export default {
        name: "DevBasic",
        data(){
            return{
                activeName: 'model-mng'
            }
        },
        components:{
            ModelMng,
            StorageMng,
            ActiveMng
        }
    }
</script>

<style scoped>

</style>